
    import { Component, Vue } from 'vue-property-decorator';
    import { mapMutations, mapState } from 'vuex';

    @Component({
        computed: {
            ...mapState('patient', ['patientData']),
        },
        methods: {
            ...mapMutations('patient', ['setDialogDekurs']),
        },
    })
    export default class DekursTabitem extends Vue {
        public $refs!: {
            dekurs: HTMLElement;
        };

        public reset(): void {
            setTimeout(() => {
                if (this.$refs.dekurs) {
                    this.$refs.dekurs.scrollTop = 0;
                }
            });
        }
    }
